import React from 'react';
import { useUpgradePrompts } from '@/modules/subscriptions/hooks/useUpgradePrompts';
import PremiumUpgradePrompt from './PremiumUpgradePrompt';

function UpgradePromptProvider({ children }) {
  const { upgradePrompt, hideUpgradePrompt } = useUpgradePrompts();

  return (
    <>
      {children}
      <PremiumUpgradePrompt
        isOpen={upgradePrompt.isOpen}
        onClose={hideUpgradePrompt}
        title={upgradePrompt.title}
        message={upgradePrompt.message}
        feature={upgradePrompt.feature}
      />
    </>
  );
}

export default UpgradePromptProvider;